"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangeAggregate = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const field_logic_1 = require("../field-type-registry/field-logic");
const date_1 = require("../utils/date");
function dateRangeAggregate(aggregate) {
    return (0, field_logic_1.valuesAggregator)((values, logic, field, userPreferences) => {
        var _a;
        const fromDateField = (_a = field.params.nested) === null || _a === void 0 ? void 0 : _a.find(({ slug }) => slug === "from_date");
        // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
        //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
        //  Move logic flatten to Lookup field logic
        const dates = (0, flattenDeep_1.default)(values)
            .filter((value) => !logic.isValueEmpty(value, field))
            .map((value) => ({
            date: value.from_date,
            momentDate: (0, date_1.dateToMoment)(value.from_date, userPreferences),
        }));
        if (fromDateField) {
            const displayFormat = field.params.display_format === "pill"
                ? "compact"
                : field.params.display_format;
            return aggregate(dates, fromDateField, userPreferences, displayFormat);
        }
        return null;
    });
}
exports.dateRangeAggregate = dateRangeAggregate;
